<template>
  <div class="addEdit-block">
    <el-form class="detail-form-content" ref="ruleForm" :model="ruleForm" :rules="rules" label-width="80px"
      :style="{ backgroundColor: addEditForm.addEditBoxColor }">
      <el-row>
        <el-col :span="12">
          <el-form-item class="input" v-if="type != 'info'" label="预约编号" prop="yuyuebianhao">
            <el-input v-model="ruleForm.yuyuebianhao" placeholder="预约编号" readonly></el-input>
          </el-form-item>
          <div v-else>
            <el-form-item class="input" v-if="ruleForm.yuyuebianhao" label="预约编号" prop="yuyuebianhao">
              <el-input v-model="ruleForm.yuyuebianhao" placeholder="预约编号" readonly></el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="12">
          <el-form-item class="input" v-if="type != 'info'" label="科室号" prop="keshihao">
            <el-input v-model="ruleForm.keshihao" placeholder="科室号" clearable :readonly="ro.keshihao"></el-input>
          </el-form-item>
          <div v-else>
            <el-form-item class="input" label="科室号" prop="keshihao">
              <el-input v-model="ruleForm.keshihao" placeholder="科室号" readonly></el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="12">
          <el-form-item class="input" v-if="type != 'info'" label="科室名称" prop="keshimingcheng">
            <el-input v-model="ruleForm.keshimingcheng" placeholder="科室名称" clearable
              :readonly="ro.keshimingcheng"></el-input>
          </el-form-item>
          <div v-else>
            <el-form-item class="input" label="科室名称" prop="keshimingcheng">
              <el-input v-model="ruleForm.keshimingcheng" placeholder="科室名称" readonly></el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="12">
          <el-form-item class="input" v-if="type != 'info'" label="医生姓名" prop="yishengxingming">
            <el-input v-model="ruleForm.yishengxingming" placeholder="医生姓名" clearable
              :readonly="ro.yishengxingming"></el-input>
          </el-form-item>
          <div v-else>
            <el-form-item class="input" label="医生姓名" prop="yishengxingming">
              <el-input v-model="ruleForm.yishengxingming" placeholder="医生姓名" readonly></el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="24">
          <el-form-item class="upload" v-if="type != 'info' && !ro.tupian" label="图片" prop="tupian">
            <file-upload tip="点击上传图片" action="file/upload" :limit="3" :multiple="true"
              :fileUrls="ruleForm.tupian ? ruleForm.tupian : ''" @change="tupianUploadChange"></file-upload>
          </el-form-item>
          <div v-else>
            <el-form-item v-if="ruleForm.tupian" label="图片" prop="tupian">
              <img style="margin-right:20px;" v-bind:key="index" v-for="(item, index) in ruleForm.tupian.split(',')"
                :src="$base.url + item" width="100" height="100">
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="12">
          <el-form-item class="input" v-if="type != 'info'" label="挂号费" prop="guahaofei">
            <el-input v-model="ruleForm.guahaofei" placeholder="挂号费" clearable :readonly="ro.guahaofei"></el-input>
          </el-form-item>
          <div v-else>
            <el-form-item class="input" label="挂号费" prop="guahaofei">
              <el-input v-model="ruleForm.guahaofei" placeholder="挂号费" readonly></el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="12">
          <el-form-item class="date" v-if="type != 'info'" label="预约时间" prop="yuyueshijian">
            <el-date-picker format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" v-model="ruleForm.yuyueshijian"
              type="date" :readonly="ro.yuyueshijian" placeholder="预约时间">
            </el-date-picker>
          </el-form-item>
          <div v-else>
            <el-form-item class="input" v-if="ruleForm.yuyueshijian" label="预约时间" prop="yuyueshijian">
              <el-input v-model="ruleForm.yuyueshijian" placeholder="预约时间" readonly></el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="12">
          <el-form-item class="input" v-if="type != 'info'" label="用户账号" prop="yonghuzhanghao">
            <el-input v-model="ruleForm.yonghuzhanghao" placeholder="用户账号" clearable
              :readonly="ro.yonghuzhanghao"></el-input>
          </el-form-item>
          <div v-else>
            <el-form-item class="input" label="用户账号" prop="yonghuzhanghao">
              <el-input v-model="ruleForm.yonghuzhanghao" placeholder="用户账号" readonly></el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="12">
          <el-form-item class="input" v-if="type != 'info'" label="用户姓名" prop="yonghuxingming">
            <el-input v-model="ruleForm.yonghuxingming" placeholder="用户姓名" clearable
              :readonly="ro.yonghuxingming"></el-input>
          </el-form-item>
          <div v-else>
            <el-form-item class="input" label="用户姓名" prop="yonghuxingming">
              <el-input v-model="ruleForm.yonghuxingming" placeholder="用户姓名" readonly></el-input>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item v-if="type != 'info'" label="预约备注" prop="yuyuebeizhu">
            <editor style="min-width: 200px; max-width: 600px;" v-model="ruleForm.yuyuebeizhu" class="editor"
              action="file/upload">
            </editor>
          </el-form-item>
          <div v-else>
            <el-form-item v-if="ruleForm.yuyuebeizhu" label="预约备注" prop="yuyuebeizhu">
              <div v-if="parseBeizhuHtml(ruleForm.yuyuebeizhu) === '__html__'" style="line-height:1.8;">
                <span v-html="formatBeizhuText(ruleForm.yuyuebeizhu)"></span>
              </div>
              <div v-else style="line-height:1.8;font-size:14px;">
                <div v-for="(val, key) in parseBeizhu(ruleForm.yuyuebeizhu)" :key="key">
                  <template v-if="key === 'timeSlot' && val">
                    <div><span style="color:#999;">时段：</span><span>{{val}}</span></div>
                  </template>
                  <template v-else-if="key === 'renshu' && val !== undefined && val !== null">
                    <div><span style="color:#999;">人数：</span><span>{{val}}人</span></div>
                  </template>
                  <template v-else-if="key === 'persons' && Array.isArray(val) && val.length > 0">
                    <div v-for="(p, pi) in val" :key="'p'+pi" style="margin-bottom:4px;padding-left:4px;border-left:2px solid #409EFF;">
                      <div style="color:#999;">探视人{{val.length>1?pi+1:''}}：</div>
                      <template v-if="typeof p === 'object'">
                        <div v-for="(pv, pk) in p" :key="pk" style="padding-left:8px;">
                          <template v-if="pv !== undefined && pv !== null && pv !== '' && pk !== 'timeLabel' && pk !== 'timeValue'">
                            <span style="color:#999;">{{formatFieldLabel(pk)}}：</span><span>{{pv}}</span>
                          </template>
                        </div>
                      </template>
                      <template v-else>
                        <div style="padding-left:8px;">{{p}}</div>
                      </template>
                    </div>
                  </template>
                  <template v-else-if="key === 'customFieldValues' && typeof val === 'object'">
                    <div v-for="(cv, ck) in val" :key="'cf'+ck">
                      <template v-if="ck.indexOf('_arr') < 0 && ck !== '_raw' && ck !== '_rawItem' && cv !== undefined && cv !== null && cv !== ''">
                        <div style="padding-left:4px;">
                          <span style="color:#999;">{{formatFieldLabel(ck)}}：</span>
                          <span>{{Array.isArray(cv) ? cv.join('，') : cv}}</span>
                        </div>
                      </template>
                    </div>
                  </template>
                </div>
              </div>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-form-item class="btn">
        <el-button v-if="type != 'info'" type="primary" class="btn-success" @click="onSubmit">提交</el-button>
        <el-button v-if="type != 'info'" class="btn-close" @click="back()">取消</el-button>
        <el-button v-if="type == 'info'" class="btn-close" @click="back()">返回</el-button>
      </el-form-item>
    </el-form>


  </div>
</template>
<script>
// 数字，邮件，手机，url，身份证校验
import { isNumber, isIntNumer, isEmail, isPhone, isMobile, isURL, checkIdCard } from "@/utils/validate";
export default {
  data() {
    let self = this
    var validateIdCard = (rule, value, callback) => {
      if (!value) {
        callback();
      } else if (!checkIdCard(value)) {
        callback(new Error("请输入正确的身份证号码"));
      } else {
        callback();
      }
    };
    var validateUrl = (rule, value, callback) => {
      if (!value) {
        callback();
      } else if (!isURL(value)) {
        callback(new Error("请输入正确的URL地址"));
      } else {
        callback();
      }
    };
    var validateMobile = (rule, value, callback) => {
      if (!value) {
        callback();
      } else if (!isMobile(value)) {
        callback(new Error("请输入正确的手机号码"));
      } else {
        callback();
      }
    };
    var validatePhone = (rule, value, callback) => {
      if (!value) {
        callback();
      } else if (!isPhone(value)) {
        callback(new Error("请输入正确的电话号码"));
      } else {
        callback();
      }
    };
    var validateEmail = (rule, value, callback) => {
      if (!value) {
        callback();
      } else if (!isEmail(value)) {
        callback(new Error("请输入正确的邮箱地址"));
      } else {
        callback();
      }
    };
    var validateNumber = (rule, value, callback) => {
      if (!value) {
        callback();
      } else if (!isNumber(value)) {
        callback(new Error("请输入数字"));
      } else {
        callback();
      }
    };
    var validateIntNumber = (rule, value, callback) => {
      if (!value) {
        callback();
      } else if (!isIntNumer(value)) {
        callback(new Error("请输入整数"));
      } else {
        callback();
      }
    };
    return {
      addEditForm: { "btnSaveFontColor": "rgba(0, 0, 0, 1)", "selectFontSize": "16px", "btnCancelBorderColor": "rgba(86, 97, 99, 1)", "inputBorderRadius": "0", "inputFontSize": "16px", "textareaBgColor": "#fff", "btnSaveFontSize": "14px", "textareaBorderRadius": "0", "uploadBgColor": "#fff", "textareaBorderStyle": "solid", "btnCancelWidth": "88px", "textareaHeight": "120px", "dateBgColor": "#fff", "btnSaveBorderRadius": "50%", "uploadLableFontSize": "14px", "textareaBorderWidth": "1px", "inputLableColor": "#606266", "addEditBoxColor": "#fff", "dateIconFontSize": "16px", "btnSaveBgColor": "rgba(220, 236, 238, 1)", "uploadIconFontColor": "rgba(79, 79, 79, 1)", "textareaBorderColor": "rgba(112, 112, 112, 1)", "btnCancelBgColor": "rgba(217, 217, 217, 1)", "selectLableColor": "rgba(0, 0, 0, 1)", "btnSaveBorderStyle": "solid", "dateBorderWidth": "1px", "dateLableFontSize": "14px", "dateBorderRadius": "0", "btnCancelBorderStyle": "solid", "selectLableFontSize": "14px", "selectBorderStyle": "solid", "selectIconFontColor": "rgba(0, 0, 0, 1)", "btnCancelHeight": "44px", "inputHeight": "40px", "btnCancelFontColor": "rgba(0, 0, 0, 1)", "dateBorderColor": "rgba(112, 112, 112, 1)", "dateIconFontColor": "rgba(0, 0, 0, 1)", "uploadBorderStyle": "solid", "dateBorderStyle": "solid", "dateLableColor": "rgba(0, 0, 0, 1)", "dateFontSize": "16px", "inputBorderWidth": "1px", "uploadIconFontSize": "28px", "selectHeight": "40px", "inputFontColor": "#606266", "uploadHeight": "148px", "textareaLableColor": "rgba(0, 0, 0, 1)", "textareaLableFontSize": "14px", "btnCancelFontSize": "14px", "inputBorderStyle": "solid", "btnCancelBorderRadius": "50%", "inputBgColor": "#fff", "inputLableFontSize": "14px", "uploadLableColor": "rgba(0, 0, 0, 1)", "uploadBorderRadius": "0", "btnSaveHeight": "44px", "selectBgColor": "#fff", "btnSaveWidth": "88px", "selectIconFontSize": "16px", "dateHeight": "40px", "selectBorderColor": "rgba(112, 112, 112, 1)", "inputBorderColor": "rgba(112, 112, 112, 1)", "uploadBorderColor": "rgba(112, 112, 112, 1)", "textareaFontColor": "rgba(0, 0, 0, 1)", "selectBorderWidth": "1px", "dateFontColor": "rgba(0, 0, 0, 1)", "btnCancelBorderWidth": "1px 5px 1px 0", "uploadBorderWidth": "1px", "textareaFontSize": "16px", "selectBorderRadius": "0", "selectFontColor": "rgba(0, 0, 0, 1)", "btnSaveBorderColor": "rgba(86, 97, 99, 1)", "btnSaveBorderWidth": "1px 5px 1px 0" },
      id: '',
      type: '',
      ro: {
        yuyuebianhao: false,
        keshihao: false,
        keshimingcheng: false,
        yishengxingming: false,
        tupian: false,
        guahaofei: false,
        yuyueshijian: false,
        yuyuebeizhu: false,
        yonghuzhanghao: false,
        yonghuxingming: false,
        sfsh: false,
        shhf: false,
        ispay: false,
      },
      ruleForm: {
        yuyuebianhao: this.getUUID(),
        keshihao: '',
        keshimingcheng: '',
        yishengxingming: '',
        tupian: '',
        guahaofei: '',
        yuyueshijian: '',
        yuyuebeizhu: '',
        yonghuzhanghao: '',
        yonghuxingming: '',
        shhf: '',
      },
      rules: {
        yuyuebianhao: [
        ],
        keshihao: [
        ],
        keshimingcheng: [
        ],
        yishengxingming: [
        ],
        tupian: [
        ],
        guahaofei: [
          { validator: validateNumber, trigger: 'blur' },
        ],
        yuyueshijian: [
        ],
        yuyuebeizhu: [
        ],
        yonghuzhanghao: [
        ],
        yonghuxingming: [
        ],
        sfsh: [
        ],
        shhf: [
        ],
        ispay: [
        ],
      }
    };
  },
  props: ["parent"],
  computed: {



  },
  created() {
    this.ruleForm.yuyueshijian = this.getCurDate()
    this.addEditStyleChange()
    this.addEditUploadStyleChange()
  },
  methods: {
    // 下载
    download(file) {
      window.open(`${file}`)
    },
    // 初始化
    init(id, type) {
      if (id) {
        this.id = id;
        this.type = type;
      }
      if (this.type == 'info' || this.type == 'else') {
        this.info(id);
      } else if (this.type == 'logistics') {
        this.logistics = false;
        this.info(id);
      } else if (this.type == 'cross') {
        var obj = this.$storage.getObj('crossObj');
        for (var o in obj) {
          if (o == 'yuyuebianhao') {
            this.ruleForm.yuyuebianhao = obj[o];
            this.ro.yuyuebianhao = true;
            continue;
          }
          if (o == 'keshihao') {
            this.ruleForm.keshihao = obj[o];
            this.ro.keshihao = true;
            continue;
          }
          if (o == 'keshimingcheng') {
            this.ruleForm.keshimingcheng = obj[o];
            this.ro.keshimingcheng = true;
            continue;
          }
          if (o == 'yishengxingming') {
            this.ruleForm.yishengxingming = obj[o];
            this.ro.yishengxingming = true;
            continue;
          }
          if (o == 'tupian') {
            this.ruleForm.tupian = obj[o];
            this.ro.tupian = true;
            continue;
          }
          if (o == 'guahaofei') {
            this.ruleForm.guahaofei = obj[o];
            this.ro.guahaofei = true;
            continue;
          }
          if (o == 'yuyueshijian') {
            this.ruleForm.yuyueshijian = obj[o];
            this.ro.yuyueshijian = true;
            continue;
          }
          if (o == 'yuyuebeizhu') {
            this.ruleForm.yuyuebeizhu = obj[o];
            this.ro.yuyuebeizhu = true;
            continue;
          }
          if (o == 'yonghuzhanghao') {
            this.ruleForm.yonghuzhanghao = obj[o];
            this.ro.yonghuzhanghao = true;
            continue;
          }
          if (o == 'yonghuxingming') {
            this.ruleForm.yonghuxingming = obj[o];
            this.ro.yonghuxingming = true;
            continue;
          }
        }
      }
      // 获取用户信息
      this.$http({
        url: `${this.$storage.get('sessionTable')}/session`,
        method: "get"
      }).then(({ data }) => {
        if (data && data.code === 0) {
          var json = data.data;
          if (json.yonghuzhanghao != '' && json.yonghuzhanghao) {
            this.ruleForm.yonghuzhanghao = json.yonghuzhanghao
            this.ro.yonghuzhanghao = true;
          }
          if (json.yonghuxingming != '' && json.yonghuxingming) {
            this.ruleForm.yonghuxingming = json.yonghuxingming
            this.ro.yonghuxingming = true;
          }
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    // 多级联动参数
    info(id) {
      this.$http({
        url: `yuyuexinxi/info/${id}`,
        method: "get"
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.ruleForm = data.data;
          //解决前台上传图片后台不显示的问题
          let reg = new RegExp('../../../upload', 'g')//g代表全部
          if (this.ruleForm.yuyuebeizhu) {
            this.ruleForm.yuyuebeizhu = this.ruleForm.yuyuebeizhu.replace(reg, '../../../ssm68n0w/upload');
          }
          // 加载表单字段标签映射
          this.loadFormFieldLabels();
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    parseBeizhu(beizhu) {
      if (!beizhu) return {};
      try {
        var parsed = JSON.parse(beizhu);
        return parsed;
      } catch(e) {
        return { '_raw': beizhu };
      }
    },
    parseBeizhuHtml(beizhu) {
      if (!beizhu) return '__json__';
      try {
        JSON.parse(beizhu);
        return '__json__';
      } catch(e) {
        return '__html__';
      }
    },
    formatBeizhuText(beizhu) {
      if (!beizhu) return '';
      return beizhu.replace(/<[^>]*>/g, '').replace(/undefined/g, '').substring(0, 300);
    },
    formatFieldLabel(key) {
      var labels = this.$storage.get('formFieldLabels');
      if (labels && labels[key]) {
        return labels[key];
      }
      var commonMap = {
        'xingming': '姓名',
        'xingbie': '性别',
        'chushengriqi': '出生日期',
        'aihao': '爱好',
        'aihao_arr': '爱好',
        'nianling': '年龄',
        'shoujihao': '手机号',
        'shenfenzheng': '身份证',
        'dizhi': '地址',
        'beizhu': '备注',
        'timeLabel': '时段',
        'timeValue': '时段值'
      };
      if (commonMap[key]) return commonMap[key];
      return key;
    },
    loadFormFieldLabels() {
      var self = this;
      this.$http({
        url: 'formField/list',
        method: 'get',
        params: { formGroup: 'yuyue' }
      }).then(function(result) {
        if (result && result.data && result.data.code === 0) {
          var labels = {};
          var fields = result.data.data;
          if (fields && fields.length) {
            for (var i = 0; i < fields.length; i++) {
              labels[fields[i].fieldName] = fields[i].fieldLabel;
            }
          }
          self.$storage.set('formFieldLabels', labels);
        }
      }).catch(function() {});
    },


    // 提交
    onSubmit() {










      if (this.ruleForm.tupian != null) {
        this.ruleForm.tupian = this.ruleForm.tupian.replace(new RegExp(this.$base.url, "g"), "");
      }

















      var objcross = this.$storage.getObj('crossObj');

      //更新跨表属性
      var crossuserid;
      var crossrefid;
      var crossoptnum;
      if (this.type == 'cross') {
        var statusColumnName = this.$storage.get('statusColumnName');
        var statusColumnValue = this.$storage.get('statusColumnValue');
        if (statusColumnName != '') {
          var obj = this.$storage.getObj('crossObj');
          if (!statusColumnName.startsWith("[")) {
            for (var o in obj) {
              if (o == statusColumnName) {
                obj[o] = statusColumnValue;
              }
            }
            var table = this.$storage.get('crossTable');
            this.$http({
              url: `${table}/update`,
              method: "post",
              data: obj
            }).then(({ data }) => { });
          } else {
            crossuserid = this.$storage.get('userid');
            crossrefid = obj['id'];
            crossoptnum = this.$storage.get('statusColumnName');
            crossoptnum = crossoptnum.replace(/\[/, "").replace(/\]/, "");
          }
        }
      }
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          if (crossrefid && crossuserid) {
            this.ruleForm.crossuserid = crossuserid;
            this.ruleForm.crossrefid = crossrefid;
            let params = {
              page: 1,
              limit: 10,
              crossuserid: this.ruleForm.crossuserid,
              crossrefid: this.ruleForm.crossrefid,
            }
            this.$http({
              url: "yuyuexinxi/page",
              method: "get",
              params: params
            }).then(({
              data
            }) => {
              if (data && data.code === 0) {
                if (data.data.total >= crossoptnum) {
                  this.$message.error(this.$storage.get('tips'));
                  return false;
                } else {
                  this.$http({
                    url: `yuyuexinxi/${!this.ruleForm.id ? "save" : "update"}`,
                    method: "post",
                    data: this.ruleForm
                  }).then(({ data }) => {
                    if (data && data.code === 0) {
                      this.$message({
                        message: "操作成功",
                        type: "success",
                        duration: 1500,
                        onClose: () => {
                          this.parent.showFlag = true;
                          this.parent.addOrUpdateFlag = false;
                          this.parent.yuyuexinxiCrossAddOrUpdateFlag = false;
                          this.parent.search();
                          this.parent.contentStyleChange();
                        }
                      });
                    } else {
                      this.$message.error(data.msg);
                    }
                  });

                }
              } else {
              }
            });
          } else {
            this.$http({
              url: `yuyuexinxi/${!this.ruleForm.id ? "save" : "update"}`,
              method: "post",
              data: this.ruleForm
            }).then(({ data }) => {
              if (data && data.code === 0) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                  duration: 1500,
                  onClose: () => {
                    this.parent.showFlag = true;
                    this.parent.addOrUpdateFlag = false;
                    this.parent.yuyuexinxiCrossAddOrUpdateFlag = false;
                    this.parent.search();
                    this.parent.contentStyleChange();
                  }
                });
              } else {
                this.$message.error(data.msg);
              }
            });
          }
        }
      });
    },
    // 获取uuid
    getUUID() {
      return new Date().getTime();
    },
    // 返回
    back() {
      this.parent.showFlag = true;
      this.parent.addOrUpdateFlag = false;
      this.parent.yuyuexinxiCrossAddOrUpdateFlag = false;
      this.parent.contentStyleChange();
    },
    tupianUploadChange(fileUrls) {
      this.ruleForm.tupian = fileUrls;
      this.addEditUploadStyleChange()
    },
    addEditStyleChange() {
      this.$nextTick(() => {
        // input
        document.querySelectorAll('.addEdit-block .input .el-input__inner').forEach(el => {
          el.style.height = this.addEditForm.inputHeight
          el.style.color = this.addEditForm.inputFontColor
          el.style.fontSize = this.addEditForm.inputFontSize
          el.style.borderWidth = this.addEditForm.inputBorderWidth
          el.style.borderStyle = this.addEditForm.inputBorderStyle
          el.style.borderColor = this.addEditForm.inputBorderColor
          el.style.borderRadius = this.addEditForm.inputBorderRadius
          el.style.backgroundColor = this.addEditForm.inputBgColor
        })
        document.querySelectorAll('.addEdit-block .input .el-form-item__label').forEach(el => {
          el.style.lineHeight = this.addEditForm.inputHeight
          el.style.color = this.addEditForm.inputLableColor
          el.style.fontSize = this.addEditForm.inputLableFontSize
        })
        // select
        document.querySelectorAll('.addEdit-block .select .el-input__inner').forEach(el => {
          el.style.height = this.addEditForm.selectHeight
          el.style.color = this.addEditForm.selectFontColor
          el.style.fontSize = this.addEditForm.selectFontSize
          el.style.borderWidth = this.addEditForm.selectBorderWidth
          el.style.borderStyle = this.addEditForm.selectBorderStyle
          el.style.borderColor = this.addEditForm.selectBorderColor
          el.style.borderRadius = this.addEditForm.selectBorderRadius
          el.style.backgroundColor = this.addEditForm.selectBgColor
        })
        document.querySelectorAll('.addEdit-block .select .el-form-item__label').forEach(el => {
          el.style.lineHeight = this.addEditForm.selectHeight
          el.style.color = this.addEditForm.selectLableColor
          el.style.fontSize = this.addEditForm.selectLableFontSize
        })
        document.querySelectorAll('.addEdit-block .select .el-select__caret').forEach(el => {
          el.style.color = this.addEditForm.selectIconFontColor
          el.style.fontSize = this.addEditForm.selectIconFontSize
        })
        // date
        document.querySelectorAll('.addEdit-block .date .el-input__inner').forEach(el => {
          el.style.height = this.addEditForm.dateHeight
          el.style.color = this.addEditForm.dateFontColor
          el.style.fontSize = this.addEditForm.dateFontSize
          el.style.borderWidth = this.addEditForm.dateBorderWidth
          el.style.borderStyle = this.addEditForm.dateBorderStyle
          el.style.borderColor = this.addEditForm.dateBorderColor
          el.style.borderRadius = this.addEditForm.dateBorderRadius
          el.style.backgroundColor = this.addEditForm.dateBgColor
        })
        document.querySelectorAll('.addEdit-block .date .el-form-item__label').forEach(el => {
          el.style.lineHeight = this.addEditForm.dateHeight
          el.style.color = this.addEditForm.dateLableColor
          el.style.fontSize = this.addEditForm.dateLableFontSize
        })
        document.querySelectorAll('.addEdit-block .date .el-input__icon').forEach(el => {
          el.style.color = this.addEditForm.dateIconFontColor
          el.style.fontSize = this.addEditForm.dateIconFontSize
          el.style.lineHeight = this.addEditForm.dateHeight
        })
        // upload
        let iconLineHeight = parseInt(this.addEditForm.uploadHeight) - parseInt(this.addEditForm.uploadBorderWidth) * 2 + 'px'
        document.querySelectorAll('.addEdit-block .upload .el-upload--picture-card').forEach(el => {
          el.style.width = this.addEditForm.uploadHeight
          el.style.height = this.addEditForm.uploadHeight
          el.style.borderWidth = this.addEditForm.uploadBorderWidth
          el.style.borderStyle = this.addEditForm.uploadBorderStyle
          el.style.borderColor = this.addEditForm.uploadBorderColor
          el.style.borderRadius = this.addEditForm.uploadBorderRadius
          el.style.backgroundColor = this.addEditForm.uploadBgColor
        })
        document.querySelectorAll('.addEdit-block .upload .el-form-item__label').forEach(el => {
          el.style.lineHeight = this.addEditForm.uploadHeight
          el.style.color = this.addEditForm.uploadLableColor
          el.style.fontSize = this.addEditForm.uploadLableFontSize
        })
        document.querySelectorAll('.addEdit-block .upload .el-icon-plus').forEach(el => {
          el.style.color = this.addEditForm.uploadIconFontColor
          el.style.fontSize = this.addEditForm.uploadIconFontSize
          el.style.lineHeight = iconLineHeight
          el.style.display = 'block'
        })
        // 多文本输入框
        document.querySelectorAll('.addEdit-block .textarea .el-textarea__inner').forEach(el => {
          el.style.height = this.addEditForm.textareaHeight
          el.style.color = this.addEditForm.textareaFontColor
          el.style.fontSize = this.addEditForm.textareaFontSize
          el.style.borderWidth = this.addEditForm.textareaBorderWidth
          el.style.borderStyle = this.addEditForm.textareaBorderStyle
          el.style.borderColor = this.addEditForm.textareaBorderColor
          el.style.borderRadius = this.addEditForm.textareaBorderRadius
          el.style.backgroundColor = this.addEditForm.textareaBgColor
        })
        document.querySelectorAll('.addEdit-block .textarea .el-form-item__label').forEach(el => {
          // el.style.lineHeight = this.addEditForm.textareaHeight
          el.style.color = this.addEditForm.textareaLableColor
          el.style.fontSize = this.addEditForm.textareaLableFontSize
        })
        // 保存
        document.querySelectorAll('.addEdit-block .btn .btn-success').forEach(el => {
          el.style.width = this.addEditForm.btnSaveWidth
          el.style.height = this.addEditForm.btnSaveHeight
          el.style.color = this.addEditForm.btnSaveFontColor
          el.style.fontSize = this.addEditForm.btnSaveFontSize
          el.style.borderWidth = this.addEditForm.btnSaveBorderWidth
          el.style.borderStyle = this.addEditForm.btnSaveBorderStyle
          el.style.borderColor = this.addEditForm.btnSaveBorderColor
          el.style.borderRadius = this.addEditForm.btnSaveBorderRadius
          el.style.backgroundColor = this.addEditForm.btnSaveBgColor
        })
        // 返回
        document.querySelectorAll('.addEdit-block .btn .btn-close').forEach(el => {
          el.style.width = this.addEditForm.btnCancelWidth
          el.style.height = this.addEditForm.btnCancelHeight
          el.style.color = this.addEditForm.btnCancelFontColor
          el.style.fontSize = this.addEditForm.btnCancelFontSize
          el.style.borderWidth = this.addEditForm.btnCancelBorderWidth
          el.style.borderStyle = this.addEditForm.btnCancelBorderStyle
          el.style.borderColor = this.addEditForm.btnCancelBorderColor
          el.style.borderRadius = this.addEditForm.btnCancelBorderRadius
          el.style.backgroundColor = this.addEditForm.btnCancelBgColor
        })
      })
    },
    addEditUploadStyleChange() {
      this.$nextTick(() => {
        document.querySelectorAll('.addEdit-block .upload .el-upload-list--picture-card .el-upload-list__item').forEach(el => {
          el.style.width = this.addEditForm.uploadHeight
          el.style.height = this.addEditForm.uploadHeight
          el.style.borderWidth = this.addEditForm.uploadBorderWidth
          el.style.borderStyle = this.addEditForm.uploadBorderStyle
          el.style.borderColor = this.addEditForm.uploadBorderColor
          el.style.borderRadius = this.addEditForm.uploadBorderRadius
          el.style.backgroundColor = this.addEditForm.uploadBgColor
        })
      })
    },
  }
};
</script>
<style lang="scss">
.editor {
  height: 500px;

  & ::v-deep .ql-container {
    height: 310px;
  }
}

.amap-wrapper {
  width: 100%;
  height: 500px;
}

.search-box {
  position: absolute;
}

.addEdit-block {
  margin: -10px;
}

.detail-form-content {
  padding: 12px;
  background-color: transparent;
}

.btn .el-button {
  padding: 0;
}
</style>
